import { render, staticRenderFns } from "./ElementalChat.vue?vue&type=template&id=42462790&scoped=true&"
import script from "./ElementalChat.vue?vue&type=script&lang=js&"
export * from "./ElementalChat.vue?vue&type=script&lang=js&"
import style0 from "./ElementalChat.vue?vue&type=style&index=0&id=42462790&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42462790",
  null
  
)

export default component.exports